import { Flame } from "lucide-react";

export const StreamConsole = ({ text, title = "L'AI sta forgiando le tue idee" }) => {
  const names = [...text.matchAll(/"nome"\s*:\s*"([^"]+)"/g)].map((m) => m[1]);
  return (
    <div className="rounded-2xl border border-amber-500/20 bg-[#0d0f17] overflow-hidden" data-testid="stream-console">
      <div className="flex items-center gap-3 px-5 py-3 border-b border-white/5">
        <span className="w-7 h-7 rounded-lg bg-amber-500/15 grid place-items-center forge-pulse">
          <Flame className="w-4 h-4 text-amber-400" />
        </span>
        <span className="text-sm font-medium text-slate-200">{title}…</span>
        <span className="ml-auto font-mono text-xs text-slate-500">{text.length} caratteri</span>
      </div>
      {names.length > 0 && (
        <div className="px-5 pt-4 flex flex-wrap gap-2" data-testid="stream-console-names">
          {names.map((n) => (
            <span key={n} className="fade-up text-xs font-semibold text-amber-200 bg-amber-500/10 border border-amber-500/25 rounded-full px-3 py-1">
              {n}
            </span>
          ))}
        </div>
      )}
      <pre className="font-mono text-[12px] leading-relaxed text-slate-400 px-5 py-4 max-h-56 overflow-hidden whitespace-pre-wrap break-words">
        <span className="cursor-blink">{text.slice(-900)}</span>
      </pre>
    </div>
  );
};
